<template>
  <div
    class="layout relative min-h-screen bg-gradient-to-b from-secondary to-secondary-300 flex justify-center items-start px-3"
  >
    <img
      :src="logoSrc"
      alt="MyLight150"
      class="absolute top-1 left-1/2 -translate-x-1/2 h-[60px] w-auto"
    />
    <div
      ref="containerRef"
      class="layout__container w-full max-w-4xl min-h-[400px] overflow-y-auto rounded-lg bg-cime-white pt-5 pb-10 px-12 flex flex-col"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import logoSrc from '@/assets/images/subscription/v1.mylight150_logo_text_white.svg';

const containerRef = ref<HTMLElement | null>(null);
const route = useRoute();

watch(
  () => route.name,
  () => {
    containerRef.value?.scrollTo({ top: 0, behavior: 'instant' });
  }
);
</script>

<style scoped>
.layout {
  --container-pt: 70px;
  --container-pb: 12px;
  padding-top: var(--container-pt);
  padding-bottom: var(--container-pb);
}

@media (min-width: 640px) {
  .layout {
    --container-pb: 40px;
  }
}

.layout__container {
  height: calc(100vh - var(--container-pt) - var(--container-pb));
}
</style>
